import React, { useState } from 'react'
import './postReelDetails.css'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { useEffect } from 'react'
import { PostsReelsConst } from '../Dashboard'
import { Button } from 'react-bootstrap'
import { CommentBgImage, CommentsIcon, DummyImage, InHeartIcon, UserImage, ViewsIcon } from 'assets'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import { formatNumber } from 'utils/formatNumber'
import { useDispatch, useSelector } from 'react-redux'
import { instagramPostType, videStatusConst } from 'constant/const'
import {
   getPostDetailsAction,
   resetIsBackToPost,
   setAllPostDataAction
} from 'store/action/instagramDashboard'
import { Loader } from 'components'
import { getEmotionIcon } from 'utils/getEmotionIcon'
import { getSentimentIcon } from 'utils/getSentimentIcon'
import PostsDetails from './PostsDetails'
import InSentimentScore from './InSentimentScore'
import InVEmotionsScore from './InVEmotionsScore'
import InAtenyaAi from './InAtenyaAi'
import PostLineChart from './PostLineChart'
import PostComments from './PostComments'

dayjs.extend(relativeTime)

function PostReelDetails() {
   const param = useParams()
   // const [postDetails, setPostDetails] = useState(null)
   const navigate = useNavigate()
   const authData = useSelector((state) => state.user)
   const { userData } = authData
   const dispatch = useDispatch()
   const location = useLocation()

   const instagramDashboardData = useSelector((state) => state.instagramDashboard)
   const {
      loading,
      postDetails,
      loadingComment,
      postLineChartDataLoader,
      allPostData,
      loadMoreComments,
      isBackToPost
   } = instagramDashboardData

   useEffect(() => {
      if (param.id) {
         if (location.state?.type === 'full') {
            dispatch(getPostDetailsAction({ id: param.id, analyze: location.state?.type }))
         } else {
            dispatch(getPostDetailsAction({ id: param.id, analyze: location.state?.type }))
         }
      }
      return () => {}
   }, [param, location])

   useEffect(() => {
      if (loadMoreComments) {
         dispatch(getPostDetailsAction({ id: param.id }))
      }
      return () => {}
   }, [loadMoreComments])

   useEffect(() => {
      if (isBackToPost) {
         if (allPostData && allPostData?.length > 0) {
            let result = allPostData.map((video) =>
               video.id === param?.id
                  ? {
                       ...video,
                       status: videStatusConst.processing
                    }
                  : video
            )
            // console.log('aa', result, allVideoData)
            dispatch(setAllPostDataAction(result))
         }
         dispatch(resetIsBackToPost())
         navigate(`/instagram/posts-reel`)
      }
      return () => {
         dispatch(resetIsBackToPost())
      }
   }, [isBackToPost, allPostData])

   // find top
   function findTopEmotionByType(positive = [], negative = [], neutral = []) {
      // Combine and tag each emotion with its category
      const combined = [
         ...positive.map((item) => ({ ...item, emotion: 'positive' })),
         ...negative.map((item) => ({ ...item, emotion: 'negative' })),
         ...neutral.map((item) => ({ ...item, emotion: 'neutral' }))
      ]

      // Return null if no data
      if (combined.length === 0) {
         return null
      }

      // Find the emotion with the highest count
      const top = combined.reduce((max, item) => {
         return item.count > max.count ? item : max
      })

      // Return top emotion details
      return {
         type: top.text,
         count: top.count,
         emotion: top.emotion
      }
   }

   // update all video list for casing
   useEffect(() => {
      if (postDetails && postDetails?.id && allPostData && allPostData?.length > 0) {
         let top_emotion = findTopEmotionByType(
            postDetails?.top_positive_comments || [],
            postDetails?.top_negative_comments || [],
            postDetails?.top_neutral_comments || []
         )
         let result = allPostData.map((video) =>
            video.id === postDetails?.id
               ? {
                    ...video,
                    is_analyzed: postDetails?.is_analyzed,
                    top_emotion: {
                       count: top_emotion?.count,
                       emotion: top_emotion?.type,
                       top_sentiment: top_emotion?.emotion,
                       top_sentiment_percentage: ''
                    },
                    analyzed_comment_count: postDetails?.analyzed_comment_count,
                    status: postDetails?.status,
                    sentiment_score: postDetails?.sentiment_score,
                    comment_count: postDetails?.comment_count
                 }
               : video
         )
         dispatch(setAllPostDataAction(result))
      }
      return () => {}
   }, [postDetails])

   return (
      <>
         {(loading || loadingComment || postLineChartDataLoader) && (
            <Loader message={location.state?.loadingMessage || ''} />
         )}
         <div className="video-analysis-section">
            <>
               <PostsDetails />
               <div>
                  <div className="row mt-3">
                     <div className="col-12 col-lg-6 col-xl-4">
                        <InSentimentScore />
                     </div>
                     <div className="col-12 col-lg-6 col-xl-8">
                        <InVEmotionsScore />
                     </div>
                  </div>
               </div>
               <div className="mt-4">
                  <InAtenyaAi />
               </div>

               <div className="mt-4 position-relative">
                  <PostLineChart />
               </div>
               <div className="mt-4 position-relative">
                  <img className="comment-bg-image" src={CommentBgImage} alt="CommentBgImage" />
                  <PostComments />
               </div>
            </>
         </div>
      </>
   )
}

export default PostReelDetails
